module.exports = __webpack_public_path__ + "static/media/Refer a Friend - T&Cs.6cff93c4.pdf";